import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Login from './Login.jsx';
import EsqueceuSenha from './EsqueceuSenha.jsx';
import Dashboard from './Dashboard.jsx';

class App extends React.Component {

    render() {
        return (
            <Router>
                <Route exact path="/" component={Login} />
                <Route exact path="/esqueceusenha" component={EsqueceuSenha} />
                <Route exact path="/home" component={Dashboard} />
                <Route exact path="/usuarios" component={Dashboard} />
                <Route exact path="/centros" component={Dashboard} />
                <Route exact path="/estoque" component={Dashboard} />
                <Route exact path="/contas" component={Dashboard} />
                <Route exact path="/movimentacoes" component={Dashboard} />
                <Route exact path="/relatorios" component={Dashboard} />
                <Route exact path="/mudarsenha" component={Dashboard} />
                <Route exact path="/cadastrarusuario" component={Dashboard} />
                <Route exact path="/visualizarusuario" component={Dashboard} />
                <Route exact path="/editarusuario" component={Dashboard} />
                <Route exact path="/cadastrarcentro" component={Dashboard} />
                <Route exact path="/visualizarcentro" component={Dashboard} />
                <Route exact path="/editarcentro" component={Dashboard} />
                <Route exact path="/estoquecentro" component={Dashboard} />
                <Route exact path="/cadastrarproduto" component={Dashboard} />
                <Route exact path="/visualizarproduto" component={Dashboard} />
                <Route exact path="/editarestoque" component={Dashboard} />
                <Route exact path="/abastecerestoque" component={Dashboard} />
                <Route exact path="/baixaestoque" component={Dashboard} />
                <Route exact path="/fluxoproduto" component={Dashboard} />
                <Route exact path="/fluxoestoque" component={Dashboard} />
                <Route exact path="/contascentro" component={Dashboard} />
                <Route exact path="/cadastrarconta" component={Dashboard} />
                <Route exact path="/visualizarconta" component={Dashboard} />
                <Route exact path="/editarconta" component={Dashboard} />
                <Route exact path="/tiposconta" component={Dashboard} />
                <Route exact path="/cadastrartipoconta" component={Dashboard} />
                <Route exact path="/visualizartipoconta" component={Dashboard} />
                <Route exact path="/editartipoconta" component={Dashboard} />
                <Route exact path="/orcamento" component={Dashboard} />
                <Route exact path="/cadastrarorcamento" component={Dashboard} />
                <Route exact path="/movimentacoescentro" component={Dashboard} />
                <Route exact path="/cadastrarmovimentacao" component={Dashboard} />
                <Route exact path="/visualizarmovimentacao" component={Dashboard} />
                <Route exact path="/editarmovimentacao" component={Dashboard} />
                <Route exact path="/removermovimentacao" component={Dashboard} />
                <Route exact path="/aprovarmovimentacao" component={Dashboard} />
                <Route exact path="/corrigirmovimentacao" component={Dashboard} />
                <Route exact path="/relatoriocontabilidade" component={Dashboard} />
                <Route exact path="/relatorioestoque" component={Dashboard} />
                <Route exact path="/resumoanual" component={Dashboard} />
                <Route exact path="/relatoriogerencial" component={Dashboard} />
                <Route exact path="/anexarnotacorrigida" component={Dashboard} />
                <Route exact path="/anexarcomprovantecorrigido" component={Dashboard} />
            </Router>
        );
    }

}

export default App;

